import axios from 'axios';
import { useEffect, useState } from 'react';
import SumsubWebSdk from '@sumsub/websdk-react';

interface NoKyc {
  accessSDKToken: string;
}

export const NoKyc = ({ accessSDKToken }: NoKyc) => {
  if (!accessSDKToken) {
    return <div>Loading KYC...</div>;
  }

  return (
    <div style={{ height: 1000, paddingBottom: 50 }}>
      <SumsubWebSdk
        accessToken={accessSDKToken}
        expirationHandler={async () => {
          const apiURL = process.env.REACT_APP_API_URL;
          const { data } = await axios.get(`${apiURL}/kyc/sdk-token`);

          return data.data.token;
        }}
        options={{
          addViewportTag: true,
          adaptIframeHeight: true
        }}
        config={{
          lang: 'en',
          theme: 'light'
        }}
        onMessage={(e: any) => console.log(e)}
        onError={(e: any) => console.log(e)}
      />
    </div>
  );
};
